import { CopyToClipboard } from "react-copy-to-clipboard";
import styled from "styled-components";
import { forwardRef, useEffect, useState } from "react";
import { useApp } from "../../contexts";
import * as Notification from "../../Notification";
import { CopyIcon } from "../Icons/CopyIcon";
// export const CopyIcon = () => (
//   <svg
//     className={"copy"}
//     width="20"
//     height="24"
//     viewBox="0 0 20 24"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <g clipPath="url(#clip0_381_25775)">
//       <path
//         d="M14.7654 0V2.12339H2.12339V16.8891H0V2.12339C0 1.53094 0.205161 1.02929 0.617358 0.617358C1.02848 0.206233 1.53094 0 2.12339 0H14.7654ZM17.9259 4.24678C18.4854 4.24678 18.9707 4.45302 19.3826 4.86414C19.7938 5.27607 20 5.76165 20 6.32089V21.0863C20 21.6791 19.7938 22.1804 19.3826 22.5926C18.9704 23.0038 18.4851 23.21 17.9259 23.21H6.32116C5.72844 23.21 5.22625 23.0038 4.81486 22.5926C4.40266 22.1804 4.1975 21.6791 4.1975 21.0863V6.32116C4.1975 5.76165 4.40266 5.27634 4.81486 4.86441C5.22599 4.45328 5.72844 4.24705 6.32116 4.24705H17.9259V4.24678ZM17.9259 21.0863V6.32116H6.32116V21.0866H17.9259V21.0863Z"
//         fill="url(#paint0_linear_381_25775)"
//       />
//     </g>
//     <defs>
//       <linearGradient
//         id="paint0_linear_381_25775"
//         x1="0"
//         y1="11.6058"
//         x2="20.001"
//         y2="11.6058"
//         gradientUnits="userSpaceOnUse"
//       >
//         <stop stopColor="#E5665B" />
//         <stop offset="0.00022375" stopColor="#E5665B" />
//         <stop offset="0.2" stopColor="#BC2DBD" />
//         <stop offset="0.201284" stopColor="#BC2DBD" />
//         <stop offset="0.51" stopColor="#5F00A7" />
//         <stop offset="0.512073" stopColor="#5F00A7" />
//         <stop offset="0.72" stopColor="#393DB8" />
//         <stop offset="0.720835" stopColor="#393DB8" />
//         <stop offset="1" stopColor="#048ACC" />
//       </linearGradient>
//       <clipPath id="clip0_381_25775">
//         <rect width="20" height="23.21" fill="white" />
//       </clipPath>
//     </defs>
//   </svg>
// );

const CopyValue = styled.div`
  display: flex;
  align-items: center;
  max-width: 100%;
  cursor: pointer;
  position: relative;

  &:hover {
    opacity: 0.9;
  }

  & b {
    font-weight: 700;
    font-size: 16px;
    line-height: 25px;
    color: #000000;
    margin-right: 12px;
    @media screen and (max-width: 1024px) {
      & {
        font-size: 14px;
      }
    }
  }
`;
const CopyValueIcon = styled.div`
  position: relative;  
`;
const Copied = styled.div`
  position: absolute;
  right: 25px;
  top: 2px;
  background-color: #096dd9;
  padding: 2px 16px;
  color: white;
  border-radius: 6px;
  font-size: 12px;
  white-space: nowrap;
`;

export const Copy_Link = forwardRef(({
  isShowText = true,
  icon = null,
  splitFont = 25,
  splitEnd = 5,
  numDot = 5,
  splitFontLg = 36,
  ...props
}, ref) => {
  let text = props?.text || "";
  const [copied, setCopied] = useState(false);
  const { T } = useApp();
  useEffect(() => {
    let timer;
    if (copied) {
      timer = setTimeout(() => {
        setCopied(false);
      }, 1000);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [copied]);

  const splitText = () => {
    let item = text;
    if (item.length >= splitFont + 10) {
      item = item.substring(0, splitFont);
      for (let i = 0; i < numDot; i++) {
        item += ".";
      }
      item += text.substring(text.length - splitEnd, text.length);
    }
    return item;
  };
  const splitTextLg = () => {
    let item = text;
    if (item.length >= splitFontLg + 5) {
      item = item.substring(0, splitFontLg);
      for (let i = 0; i < numDot; i++) {
        item += ".";
      }
      item += text.substring(text.length - splitEnd, text.length);
    }

    return item;
  };

  return (
    <CopyValue className="flex justify-between w-full copy">
      {isShowText && (
        <a href={text} target="_blank" rel="noopener noreferrer">
          <b style={props?.textStyle || {}}>
            {window.innerWidth <= 500 || props.cutText ? splitText(text) : splitTextLg(text)}
          </b>
        </a>
      )}
      <CopyToClipboard
        onCopy={() => {
          // setCopied(true);
          Notification.success(T("Copied"))
        }}
        text={text}
      >
        <CopyValueIcon className="copy" ref={ref}>
          {icon ? icon : <CopyIcon />}
          {/* {copied ? <Copied>{}</Copied> : null} */}
        </CopyValueIcon>
      </CopyToClipboard>
    </CopyValue>
  )
});
